var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductUsedIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10806_189299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5297 6.875H7.47038C7.14672 6.875 6.83632 7.01034 6.60746 7.25125C6.37859 7.49215 6.25002 7.81889 6.25002 8.15958V12.3602C6.24669 12.67 6.34984 12.9706 6.54046 13.2067C6.73108 13.4427 6.99633 13.5983 7.28733 13.6448V21.879C7.28733 22.2196 7.4159 22.5464 7.64476 22.7873C7.87363 23.0282 8.18403 23.1635 8.50769 23.1635H21.5045C21.8282 23.1635 22.1386 23.0282 22.3675 22.7873C22.5963 22.5464 22.7249 22.2196 22.7249 21.879V13.6062C23.0137 13.557 23.276 13.4002 23.4642 13.1644C23.6524 12.9286 23.7538 12.6295 23.75 12.3216V8.15958C23.75 7.81889 23.6214 7.49215 23.3926 7.25125C23.1637 7.01034 22.8533 6.875 22.5297 6.875ZM8.69074 9.44417H21.3093V11.0756H8.69074V9.44417ZM9.72805 20.5558V13.6448H20.2842V20.5558H9.72805Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1852 14.6211H11.8149V17.1903H18.1852V14.6211Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10806_189299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 16.25,
    fill: "white",
    transform: "translate(6.25 6.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductUsedIcn);
export default __webpack_public_path__ + "static/media/product-used-icn.a15fe46b1254890b2257aed3ace7b01d.svg";
export { ForwardRef as ReactComponent };